import type { DayPlan } from '@shared/types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * Заголовок и строка карточки «что повторить» на главной (решение владельца 2026-10-21). Повторить — слова
 * с ошибкой в прошлый раз и не встречавшиеся 3+ дня (по истории тренировок); всё повторено — что завтра.
 * «На сегодня готово» не пишем: читалось как «слов больше нет» (решение 2026-10-21).
 */
export function planCopy(plan: DayPlan, t: Translate, list: (words: string[]) => string): { title: string; sub: string } {
  if (plan.repeat > 0) {
    const kinds = [
      plan.mistakes > 0 ? t('today.mistakes', { count: plan.mistakes }) : '',
      plan.stale > 0 ? t('today.stale', { count: plan.stale }) : '',
    ]
      .filter(Boolean)
      .join(t('today.and'));
    const where = plan.modulesToRepeat > 1 ? ` · ${t('today.inModules', { count: plan.modulesToRepeat })}` : '';
    return {
      title: t(plan.doneToday > 0 ? 'today.repeatMoreTitle' : 'today.repeatTitle', { count: plan.repeat }),
      sub: kinds + where,
    };
  }
  if (plan.doneToday > 0) {
    if (plan.tomorrow > 0) {
      const first = plan.tomorrowFirst.length
        ? ` ${t('today.tomorrowFirst', { words: list(plan.tomorrowFirst) })}`
        : '';
      return {
        title: t('today.tomorrowTitle', { count: plan.tomorrow }),
        sub: t('today.doneToday', { count: plan.doneToday }) + first,
      };
    }
    return {
      title: t('today.doneCountTitle', { count: plan.doneToday }),
      sub: plan.new > 0 ? t('today.newAvailable', { count: plan.new }) : t('today.addWords'),
    };
  }
  if (plan.ready === 0) return { title: t('today.emptyTitle'), sub: t('today.emptySub') };
  if (plan.new === plan.ready) {
    return { title: t('today.startNewTitle'), sub: t('today.startNewSub', { count: plan.new }) };
  }
  return {
    title: t('today.freshTitle'),
    sub: plan.new > 0 ? t('today.newAvailable', { count: plan.new }) : t('today.freshSub'),
  };
}

/** «boarding и gate» / «boarding and gate» — союз по языку интерфейса. */
export function joinWords(words: string[], lang: string): string {
  try {
    return new Intl.ListFormat(lang, { style: 'long', type: 'conjunction' }).format(words);
  } catch {
    return words.join(', ');
  }
}
